import { useLocation, useNavigate } from "react-router-dom";

import emergencyVacationIcon from "../../../../assets/img/emergency/emergency-vacation-icon.png";

import ResultFormat from "..";

type Props = {};
export default function VacationResult(props: Props) {
  const { state } = useLocation();
  const navigate = useNavigate();

  const incidentName = state?.situation?.incidentBuildingName
    ? state?.situation?.incidentBuildingName
    : state?.situation?.incidentAddress;

  return (
    <ResultFormat
      title={"휴가/외근 중이예요"}
      description={`${incidentName ?? "-"} 건물에 ${
        incidentName?.length > 10 ? "\n" : ""
      }${
        state?.situation?.evacuationCategory
      }가 발생하였습니다.\n현재 휴가 / 외근 등으로 건물 외부에 있는 경우,\n${
        incidentName ?? "-"
      } 으로 진입하지 마시고\n안전한 장소에 머물러 주세요.`}
      icon={emergencyVacationIcon}
      onCancel={() => navigate(state?.referer)}
      isManager={false}
    />
  );
}
